import { apiClient } from "@base/api/client";
import type { MemberListParams, MemberListResponse } from "@features/admin/model/types";

export async function fetchMembers(params: MemberListParams): Promise<MemberListResponse> {
  const { data } = await apiClient.get<MemberListResponse>("/82office/membership/api/admin/members", { params });
  return data;
}
